// extracted by mini-css-extract-plugin
module.exports = {"mainViewContainer":"Home_mainViewContainer__26iZT","categoryIcon":"Home_categoryIcon__3bXxf"};